if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        let extraOptionalItems = document.querySelectorAll('optional-items input[type="checkbox"]:checked');
        let hasBundleProductConnection = document.querySelector('optional-items [data-bundle-variants-connected]');

        let replacementItemSelected = document.querySelector('optional-items.optional-items-v2 input[type="radio"]:checked[data-main-item="false"]');
        let isQuickAddForm = this.classList.contains('quick-add__form');


        if (!isQuickAddForm && hasBundleProductConnection && extraOptionalItems.length === 1) {
          if (hasBundleProductConnection.querySelectorAll('input').length === 1) {
            this.form.querySelector('[name="id"]').value = hasBundleProductConnection.querySelector('input').value;
          } else {
            let selectedVariantTitle = document.querySelector('variant-selects.main-selector input:checked').value;
            this.form.querySelector('[name="id"]').value = hasBundleProductConnection.querySelector(
              `input[name="${selectedVariantTitle}"]`,
            ).value;
          }
        } else if (!isQuickAddForm && hasBundleProductConnection) {
          this.form.querySelector('[name="id"]').value = JSON.parse(
            document.querySelector('product-info variant-selects [data-selected-variant]')?.innerHTML,
          ).id;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (!isQuickAddForm && extraOptionalItems.length > 0 && !hasBundleProductConnection) {
          let bundleNumber = Math.floor(9e4 * Math.random()) + 1e4;
          let productsID = []
          productsID.push(this.form.querySelector('[name="id"]').value)
          extraOptionalItems.forEach((item) => {
            productsID.push(item.value);
          });

          let product_data = productsID.map((variantId, index) => {
            let properties = {};
            let quantity = 1

            if (index === 0) {
              if (extraOptionalItems.length > 0) {
                properties = {
                  _bundle: bundleNumber,
                  _MainBundle: true,
                  _ExtraItems: extraOptionalItems.length
                }
              } else {
                properties = {
                  _bundle: bundleNumber
                }
              }
            } else {
              quantity = 1
              properties = {
                _bundle: bundleNumber
              }
            }
            return {quantity: quantity, id: Number(variantId), properties: properties}
          })

          product_data.reverse()

          let data = {
            items: product_data,
            sections: this.cart.getSectionsToRender().map(section => section.id),
            sections_url: window.location.pathname
          }

          config.body = JSON.stringify(data)
          config.headers['Content-Type'] = 'application/json'
        } else {
          config.body = formData;
        }

        if (!isQuickAddForm && replacementItemSelected !== null) {
          formData.set('id', replacementItemSelected.value);
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (document.querySelector('optional-items')) {
            document.querySelector('optional-items').checkInputChecked();
          } else {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
